import React from 'react';
import {
    formatGmdAmount,
    formatMsisdn,
    isPulsePay,
    isWalletMethod,
    PULSE_PAY_DISPLAY,
    PULSE_WAVE_DISPLAY,
    splitPremium,
    walletBrand,
    walletPayNumber,
    payInstruction
} from '../wallets';
import { coercePaymentMethod, defaultPaymentMethod, railEnabled } from '../tenantFeatures';

export function PaymentMethodSelect({ wallets, features, value, onChange, className }) {
    const method = coercePaymentMethod(value || defaultPaymentMethod(), features);
    const rails = (features && features.payments && features.payments.enabledRails) || ['cash'];
    return (
        <select className={className || 'form-select'} value={method} onChange={(e) => onChange(e.target.value)}>
            <option value="cash">Cash at the office</option>
            {rails.includes('pulsepay') && (
                <option value="pulsepay">Pulse Pay — {formatMsisdn((wallets && wallets.pulsePayNumber) || PULSE_PAY_DISPLAY)}</option>
            )}
            {rails.includes('wave') && (
                <option value="wave">Wave — {formatMsisdn((wallets && wallets.waveNumber) || PULSE_WAVE_DISPLAY)}</option>
            )}
            {rails.includes('orange') && <option value="orange">Orange Money</option>}
            {rails.includes('qmoney') && <option value="qmoney">QMoney</option>}
        </select>
    );
}

function WalletPayBox({
    wallets,
    features,
    policy,
    method,
    onMethodChange,
    reference,
    onReferenceChange,
    onConfirm,
    busy,
    confirmLabel
}) {
    const amount = splitPremium(policy).grossPremium;
    const payMethod = coercePaymentMethod(method || defaultPaymentMethod(), features);
    const number = formatMsisdn(walletPayNumber(wallets, payMethod));
    const brand = walletBrand(payMethod);
    const wallet = isWalletMethod(payMethod);

    return (
        <div className="border rounded p-3 bg-light">
            <div className="fw-semibold mb-2">Collect premium</div>
            <div className="row g-2 align-items-end">
                <div className="col-md-4">
                    <label className="form-label small mb-1">Method</label>
                    <PaymentMethodSelect
                        wallets={wallets}
                        features={features}
                        value={payMethod}
                        onChange={onMethodChange}
                    />
                </div>
                <div className="col-md-5">
                    <label className="form-label small mb-1">{wallet ? brand + ' confirmation' : 'Receipt note'}</label>
                    <input
                        className="form-control"
                        value={reference}
                        onChange={(e) => onReferenceChange(e.target.value)}
                        placeholder={isPulsePay(payMethod) ? 'Pulse Pay txn ref' : wallet ? brand + ' name or txn id' : 'Cash received by…'}
                    />
                </div>
                <div className="col-md-3">
                    <button type="button" className="btn btn-success w-100" disabled={busy || (wallet && !String(reference || '').trim())} onClick={onConfirm}>
                        {busy ? 'Saving…' : (confirmLabel || 'Confirm paid')}
                    </button>
                </div>
            </div>
            {wallet && railEnabled(features, payMethod) ? (
                <p className="small mb-0 mt-2">
                    {payInstruction({ amount, method: payMethod, number, policyNumber: policy.policyNumber, name: (policy.policyHolder && policy.policyHolder.fullName) || '' })}
                    {' '}Send to <strong>{number || PULSE_PAY_DISPLAY}</strong>.
                </p>
            ) : (
                <p className="small mb-0 mt-2">Collect {formatGmdAmount(amount)} cash at the office, then confirm.</p>
            )}
        </div>
    );
}

export default WalletPayBox;
